function Loader({ label = 'Please wait…' }) {
  return (
    <div className="shopLoader" role="status" aria-live="polite">
      <span className="galleryPage__spinner" aria-hidden="true" />
      <p className="shopLoader__label">{label}</p>
    </div>
  );
}

export default Loader;
